import { NgModule } from '@angular/core';

// modules
import { RouterModule, Routes } from '@angular/router';

// components
import { LearnerHomeComponent } from './components/learner-home/learner-home.component';
import { CommonModule } from '@angular/common';
import { LearnerHomeDiscoverComponent } from './components/learner-home-discover/learner-home-discover.component';
import { ProfileAssignmentsComponent } from '@app/profile/components/profile-assignments/profile-assignments.component';
import { ProfileSharedComponent } from '@app/profile/components/profile-shared/profile-shared.component';
import { ProfilePlansComponent } from '@app/profile/components/profile-plans/profile-plans.component';
import { ProfileSkillStandardsComponent } from '@app/profile/components/profile-skill-standards/profile-skill-standards.component';

// guards
import { OnboardingRequiredGuard } from './guards/onboarding-required.guard';
import { ProfileGroupsComponent } from '@app/profile/components/profile-groups/profile-groups.component';
import { ProfilePathwaysComponent } from '@app/profile/components/profile-pathways/profile-pathways.component';
import { ProfileSavedComponent } from '@app/profile/components/profile-saved/profile-saved.component';
import { ProfileAssignmentsComponent2 } from '@app/profile/components/profile-assignments/profile-assignments.component2';

const learnerHomeRoutes: Routes = [
  {
    path: 'feed',
    component: LearnerHomeComponent,
    canActivate: [OnboardingRequiredGuard],
  },
  {
    path: '',
    component: LearnerHomeComponent,
    canActivate: [OnboardingRequiredGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'discover',
      },
      {
        path: 'discover',
        component: LearnerHomeDiscoverComponent,
        data: { i18nTitle: 'Core_Discover' },
      },
      {
        path: 'assignments',
        component: ProfileAssignmentsComponent,
        data: { i18nTitle: 'DashboardNav_Assignments' },
      },
      {
        path: 'assignments-v2',
        component: ProfileAssignmentsComponent2,
        data: { i18nTitle: 'DashboardNav_Assignments' },
      },
      {
        path: 'shared',
        component: ProfileSharedComponent,
        data: { i18nTitle: 'Core_Shared' },
      },
      {
        path: 'pathways',
        component: ProfilePathwaysComponent,
        data: { i18nTitle: 'UserController_Pathways' },
      },
      {
        path: 'plans',
        component: ProfilePlansComponent,
        data: { i18nTitle: 'Core_Plans' },
      },
      {
        path: 'saved',
        component: ProfileSavedComponent,
        data: { i18nTitle: 'Core_Saved' },
      },
      {
        path: 'groups',
        component: ProfileGroupsComponent,
        data: { i18nTitle: 'UserController_GroupsTitle' },
      },
      {
        path: 'skillstandards',
        component: ProfileSkillStandardsComponent,
        data: { i18nTitle: 'SkillStd_SkillStandards' },
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(learnerHomeRoutes)],
  exports: [RouterModule],
})
export class LeanerHomeRoutingModule {}
